import { _ as _unsupportedIterableToArray } from '../../../dist/unsupportedIterableToArray-7c30dadf.esm.js';
import { _ as _toConsumableArray } from '../../../dist/toConsumableArray-0ccd58b7.esm.js';
import { _ as _objectSpread2 } from '../../../dist/objectSpread2-04e3d2b4.esm.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../dist/asyncToGenerator-9cc1acb2.esm.js';
import { a as _createClass, _ as _classCallCheck } from '../../../dist/createClass-38c45ab6.esm.js';
import { _ as _inherits, a as _createSuper, b as _assertThisInitialized } from '../../../dist/wrapNativeSuper-aecc63dc.esm.js';
import { _ as _defineProperty } from '../../../dist/defineProperty-6a97efcd.esm.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/esnext.promise.all-settled.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.from-entries.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.object.entries.js';
import * as tus from 'tus-js-client';
import 'core-js/modules/es.array.concat.js';
import fetch from 'cross-fetch';
import { HttpError } from '../../../errors/dist/livepeer-errors.esm.js';
import { d as defaultStudioConfig } from '../../../dist/provider-c391b414.esm.js';
import 'core-js/modules/es.number.is-integer.js';
import 'core-js/modules/es.number.constructor.js';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var BaseLivepeerProvider = /*#__PURE__*/function () {
  /** Provider base config */

  /** Data fetching library */

  function BaseLivepeerProvider(config) {
    _classCallCheck(this, BaseLivepeerProvider);
    _defineProperty(this, "_config", void 0);
    _defineProperty(this, "_fetch", void 0);
    this._fetch = fetch;
    this._config = config;
  }
  _createClass(BaseLivepeerProvider, [{
    key: "getConfig",
    value: function getConfig() {
      return this._config;
    }
  }, {
    key: "_get",
    value: function () {
      var _get2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, options) {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._fetch("".concat(this._config.baseUrl).concat(url), _objectSpread2({
                  method: 'GET'
                }, options));
              case 2:
                response = _context.sent;
                if (response.ok) {
                  _context.next = 10;
                  break;
                }
                _context.t0 = HttpError;
                _context.t1 = response.status;
                _context.next = 8;
                return response.json();
              case 8:
                _context.t2 = _context.sent;
                throw new _context.t0(_context.t1, 'Provider failed to get object', _context.t2);
              case 10:
                return _context.abrupt("return", response.json());
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function _get(_x, _x2) {
        return _get2.apply(this, arguments);
      }
      return _get;
    }()
  }, {
    key: "_create",
    value: function () {
      var _create2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, options) {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._fetch("".concat(this._config.baseUrl).concat(url), _objectSpread2(_objectSpread2(_objectSpread2({
                  method: 'POST'
                }, options), options !== null && options !== void 0 && options.json ? {
                  body: JSON.stringify(options.json)
                } : {}), {}, {
                  headers: _objectSpread2(_objectSpread2({}, options !== null && options !== void 0 && options.json ? {
                    'content-type': 'application/json'
                  } : {}), options === null || options === void 0 ? void 0 : options.headers)
                }));
              case 2:
                response = _context2.sent;
                if (response.ok) {
                  _context2.next = 10;
                  break;
                }
                _context2.t0 = HttpError;
                _context2.t1 = response.status;
                _context2.next = 8;
                return response.json();
              case 8:
                _context2.t2 = _context2.sent;
                throw new _context2.t0(_context2.t1, 'Provider failed to create object', _context2.t2);
              case 10:
                return _context2.abrupt("return", response.json());
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function _create(_x3, _x4) {
        return _create2.apply(this, arguments);
      }
      return _create;
    }()
  }, {
    key: "_update",
    value: function () {
      var _update2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url, options) {
        var response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._fetch("".concat(this._config.baseUrl).concat(url), _objectSpread2(_objectSpread2(_objectSpread2({
                  method: 'PATCH'
                }, options), options !== null && options !== void 0 && options.json ? {
                  body: JSON.stringify(options.json)
                } : {}), {}, {
                  headers: _objectSpread2(_objectSpread2({}, options !== null && options !== void 0 && options.json ? {
                    'content-type': 'application/json'
                  } : {}), options === null || options === void 0 ? void 0 : options.headers)
                }));
              case 2:
                response = _context3.sent;
                if (response.ok) {
                  _context3.next = 10;
                  break;
                }
                _context3.t0 = HttpError;
                _context3.t1 = response.status;
                _context3.next = 8;
                return response.json();
              case 8:
                _context3.t2 = _context3.sent;
                throw new _context3.t0(_context3.t1, 'Provider failed to update object', _context3.t2);
              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function _update(_x5, _x6) {
        return _update2.apply(this, arguments);
      }
      return _update;
    }()
  }]);
  return BaseLivepeerProvider;
}();

var StudioLivepeerProvider = /*#__PURE__*/function (_BaseLivepeerProvider) {
  _inherits(StudioLivepeerProvider, _BaseLivepeerProvider);
  var _super = _createSuper(StudioLivepeerProvider);
  function StudioLivepeerProvider(config) {
    var _this;
    _classCallCheck(this, StudioLivepeerProvider);
    _this = _super.call(this, config);
    _defineProperty(_assertThisInitialized(_this), "_defaultHeaders", void 0);
    _this._defaultHeaders = config.apiKey ? {
      Authorization: "Bearer ".concat(config.apiKey)
    } : {};
    return _this;
  }
  _createClass(StudioLivepeerProvider, [{
    key: "createStream",
    value: function () {
      var _createStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
        var studioStream;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._create('/stream', {
                  json: args,
                  headers: this._defaultHeaders
                });
              case 2:
                studioStream = _context.sent;
                return _context.abrupt("return", this._mapToStream(studioStream));
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function createStream(_x) {
        return _createStream.apply(this, arguments);
      }
      return createStream;
    }()
  }, {
    key: "updateStream",
    value: function () {
      var _updateStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(args) {
        var _args$multistream, _args$playbackPolicy;
        var streamId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                streamId = typeof args === 'string' ? args : args.streamId;
                _context2.next = 3;
                return this._update("/stream/".concat(streamId), {
                  json: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, typeof (args === null || args === void 0 ? void 0 : args.record) !== 'undefined' ? {
                    record: Boolean(args.record)
                  } : {}), typeof (args === null || args === void 0 ? void 0 : args.suspend) !== 'undefined' ? {
                    suspended: Boolean(args.suspend)
                  } : {}), typeof (args === null || args === void 0 ? void 0 : (_args$multistream = args.multistream) === null || _args$multistream === void 0 ? void 0 : _args$multistream.targets) !== 'undefined' ? {
                    multistream: {
                      targets: args.multistream.targets.map(function (t) {
                        var _t$spec;
                        return typeof t.id === 'undefined' || 'url' in ((_t$spec = t.spec) !== null && _t$spec !== void 0 ? _t$spec : {}) ? _objectSpread2(_objectSpread2({}, t), {}, {
                          id: undefined
                        }) : _objectSpread2(_objectSpread2({}, t), {}, {
                          spec: undefined
                        });
                      })
                    }
                  } : {}), typeof (args === null || args === void 0 ? void 0 : (_args$playbackPolicy = args.playbackPolicy) === null || _args$playbackPolicy === void 0 ? void 0 : _args$playbackPolicy.type) !== 'undefined' ? {
                    playbackPolicy: {
                      type: args.playbackPolicy.type
                    }
                  } : {}),
                  headers: this._defaultHeaders
                });
              case 3:
                return _context2.abrupt("return", this.getStream(streamId));
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function updateStream(_x2) {
        return _updateStream.apply(this, arguments);
      }
      return updateStream;
    }()
  }, {
    key: "getStream",
    value: function () {
      var _getStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(args) {
        var studioStream;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._get("/stream/".concat(typeof args === 'string' ? args : args.streamId), {
                  headers: this._defaultHeaders
                });
              case 2:
                studioStream = _context3.sent;
                return _context3.abrupt("return", this._mapToStream(studioStream));
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getStream(_x3) {
        return _getStream.apply(this, arguments);
      }
      return getStream;
    }()
  }, {
    key: "getStreamSession",
    value: function () {
      var _getStreamSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(args) {
        var studioStreamSession;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._get("/session/".concat(typeof args === 'string' ? args : args.streamSessionId), {
                  headers: this._defaultHeaders
                });
              case 2:
                studioStreamSession = _context4.sent;
                return _context4.abrupt("return", studioStreamSession);
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function getStreamSession(_x4) {
        return _getStreamSession.apply(this, arguments);
      }
      return getStreamSession;
    }()
  }, {
    key: "getStreamSessions",
    value: function () {
      var _getStreamSessions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(args) {
        var studioStreamSessions;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._get("/stream/".concat(typeof args === 'string' ? args : args.streamId, "/sessions"), {
                  headers: this._defaultHeaders
                });
              case 2:
                studioStreamSessions = _context5.sent;
                return _context5.abrupt("return", studioStreamSessions);
              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function getStreamSessions(_x5) {
        return _getStreamSessions.apply(this, arguments);
      }
      return getStreamSessions;
    }()
  }, {
    key: "createAsset",
    value: function () {
      var _createAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(args) {
        var _this2 = this;
        var sources, _onProgress, noWait, progress, pendingAssetIds, MAX_ERROR_COUNT, assets, mappedAssets;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                sources = args.sources, _onProgress = args.onProgress, noWait = args.noWait;
                progress = sources.map(function (source) {
                  return {
                    name: source.name,
                    progress: 0,
                    phase: source !== null && source !== void 0 && source.url ? 'waiting' : 'uploading'
                  };
                }); // upload all assets and do not throw for failed
                _context9.next = 4;
                return Promise.allSettled(sources.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(source, index) {
                    var _createdAsset$asset, createdAsset, uploadReq, tusEndpoint, assetId;
                    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (!source.url) {
                              _context6.next = 7;
                              break;
                            }
                            _context6.next = 3;
                            return _this2._create('/asset/upload/url', {
                              json: {
                                name: source.name,
                                url: source.url
                              },
                              headers: _this2._defaultHeaders
                            });
                          case 3:
                            createdAsset = _context6.sent;
                            return _context6.abrupt("return", createdAsset === null || createdAsset === void 0 ? void 0 : (_createdAsset$asset = createdAsset.asset) === null || _createdAsset$asset === void 0 ? void 0 : _createdAsset$asset.id);
                          case 7:
                            _context6.next = 9;
                            return _this2._create('/asset/request-upload', {
                              json: {
                                name: source.name
                              },
                              headers: _this2._defaultHeaders
                            });
                          case 9:
                            uploadReq = _context6.sent;
                            tusEndpoint = uploadReq.tusEndpoint, assetId = uploadReq.asset.id;
                            _context6.next = 13;
                            return new Promise(function (resolve, reject) {
                              var upload = new tus.Upload(source.file, _objectSpread2(_objectSpread2({
                                endpoint: tusEndpoint,
                                metadata: {
                                  id: assetId
                                }
                              }, source instanceof File ? null : {
                                chunkSize: 5 * 1024 * 1024
                              }), {}, {
                                // fingerprint: function (file: File & { exif?: any }) {
                                //   return fingerprint(file);
                                // },
                                onError: function onError(error) {
                                  console.log('Failed because: ', error);
                                },
                                // TODO add configurable url storage for nodejs
                                onProgress: function onProgress(bytesSent, bytesTotal) {
                                  var progressPercent = bytesSent / bytesTotal;
                                  var status = {
                                    name: source.name,
                                    progress: progressPercent,
                                    phase: 'uploading'
                                  };
                                  var newSources = _toConsumableArray(progress);
                                  newSources[index] = status;
                                  progress = newSources;
                                  _onProgress === null || _onProgress === void 0 ? void 0 : _onProgress(progress);
                                },
                                onSuccess: function onSuccess() {
                                  resolve();
                                }
                              }));
                              upload.findPreviousUploads().then(function (previousUploads) {
                                if ((previousUploads === null || previousUploads === void 0 ? void 0 : previousUploads.length) > 0 && previousUploads[0]) {
                                  upload.resumeFromPreviousUpload(previousUploads[0]);
                                }
                                upload.start();
                              }).catch(reject);
                            });
                          case 13:
                            return _context6.abrupt("return", assetId);
                          case 14:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));
                  return function (_x7, _x8) {
                    return _ref.apply(this, arguments);
                  };
                }()));
              case 4:
                pendingAssetIds = _context9.sent;
                if (!noWait) {
                  _context9.next = 7;
                  break;
                }
                return _context9.abrupt("return", Promise.all(pendingAssetIds.map( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(assetIdResult) {
                    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (!(assetIdResult.status === 'rejected')) {
                              _context7.next = 2;
                              break;
                            }
                            throw assetIdResult.reason;
                          case 2:
                            return _context7.abrupt("return", _this2.getAsset(assetIdResult.value));
                          case 3:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));
                  return function (_x9) {
                    return _ref2.apply(this, arguments);
                  };
                }())));
              case 7:
                MAX_ERROR_COUNT = 5; // wait for all assets to complete uploading before returning
                _context9.next = 10;
                return Promise.allSettled(pendingAssetIds.map( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(assetIdResult, index) {
                    var asset, errorCount, _asset, _asset$status, _asset2, _asset2$status, _asset$status2, _asset$status$progres, _status, _newSources, status, newSources;
                    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (!(assetIdResult.status === 'rejected')) {
                              _context8.next = 2;
                              break;
                            }
                            throw assetIdResult.reason;
                          case 2:
                            asset = null;
                            errorCount = 0;
                          case 4:
                            if (!(((_asset = asset) === null || _asset === void 0 ? void 0 : (_asset$status = _asset.status) === null || _asset$status === void 0 ? void 0 : _asset$status.phase) !== 'ready' && ((_asset2 = asset) === null || _asset2 === void 0 ? void 0 : (_asset2$status = _asset2.status) === null || _asset2$status === void 0 ? void 0 : _asset2$status.phase) !== 'failed')) {
                              _context8.next = 21;
                              break;
                            }
                            _context8.prev = 5;
                            _context8.next = 8;
                            return new Promise(function (resolve) {
                              return setTimeout(resolve, Math.random() * 1000 + 4000);
                            });
                          case 8:
                            _context8.next = 10;
                            return _this2.getAsset(assetIdResult.value);
                          case 10:
                            asset = _context8.sent;
                            if (typeof ((_asset$status2 = asset.status) === null || _asset$status2 === void 0 ? void 0 : _asset$status2.phase) !== 'undefined') {
                              _status = {
                                name: asset.name,
                                progress: (_asset$status$progres = asset.status.progress) !== null && _asset$status$progres !== void 0 ? _asset$status$progres : 0,
                                phase: asset.status.phase
                              };
                              _newSources = _toConsumableArray(progress);
                              _newSources[index] = _status;
                              progress = _newSources;
                              _onProgress === null || _onProgress === void 0 ? void 0 : _onProgress(progress);
                            }
                            _context8.next = 19;
                            break;
                          case 14:
                            _context8.prev = 14;
                            _context8.t0 = _context8["catch"](5);
                            if (!(errorCount > MAX_ERROR_COUNT)) {
                              _context8.next = 18;
                              break;
                            }
                            throw _context8.t0;
                          case 18:
                            errorCount += 1;
                          case 19:
                            _context8.next = 4;
                            break;
                          case 21:
                            status = {
                              name: asset.name,
                              progress: 1,
                              phase: asset.status.phase
                            };
                            newSources = _toConsumableArray(progress);
                            newSources[index] = status;
                            progress = newSources;
                            _onProgress === null || _onProgress === void 0 ? void 0 : _onProgress(progress);
                            return _context8.abrupt("return", asset);
                          case 27:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8, null, [[5, 14]]);
                  }));
                  return function (_x10, _x11) {
                    return _ref3.apply(this, arguments);
                  };
                }()));
              case 10:
                assets = _context9.sent;
                mappedAssets = _toConsumableArray(assets.map(function (asset) {
                  if (asset.status === 'fulfilled') {
                    return asset.value;
                  } else {
                    throw asset.reason;
                  }
                }));
                return _context9.abrupt("return", mappedAssets);
              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
      function createAsset(_x6) {
        return _createAsset.apply(this, arguments);
      }
      return createAsset;
    }()
  }, {
    key: "getAsset",
    value: function () {
      var _getAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(args) {
        var studioAsset;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._get("/asset/".concat(typeof args === 'string' ? args : args.assetId), {
                  headers: this._defaultHeaders
                });
              case 2:
                studioAsset = _context10.sent;
                return _context10.abrupt("return", studioAsset);
              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
      function getAsset(_x12) {
        return _getAsset.apply(this, arguments);
      }
      return getAsset;
    }()
  }, {
    key: "updateAsset",
    value: function () {
      var _updateAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(args) {
        var _storage$metadata, _storage$metadataTemp;
        var assetId, name, storage;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                assetId = args.assetId, name = args.name, storage = args.storage;
                _context11.next = 3;
                return this._update("/asset/".concat(assetId), {
                  json: {
                    name: typeof name !== 'undefined' ? String(name) : undefined,
                    storage: storage !== null && storage !== void 0 && storage.ipfs ? {
                      ipfs: {
                        spec: {
                          nftMetadata: (_storage$metadata = storage === null || storage === void 0 ? void 0 : storage.metadata) !== null && _storage$metadata !== void 0 ? _storage$metadata : {},
                          nftMetadataTemplate: (_storage$metadataTemp = storage === null || storage === void 0 ? void 0 : storage.metadataTemplate) !== null && _storage$metadataTemp !== void 0 ? _storage$metadataTemp : 'player'
                        }
                      }
                    } : undefined
                  },
                  headers: this._defaultHeaders
                });
              case 3:
                return _context11.abrupt("return", this.getAsset({
                  assetId: assetId
                }));
              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
      function updateAsset(_x13) {
        return _updateAsset.apply(this, arguments);
      }
      return updateAsset;
    }()
  }, {
    key: "_getRtmpIngestUrl",
    value: function _getRtmpIngestUrl(streamKey) {
      return "rtmp://rtmp.livepeer.com/live/".concat(streamKey);
    }
  }, {
    key: "getPlaybackInfo",
    value: function () {
      var _getPlaybackInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(args) {
        var playbackId, urlEncodedPlaybackId, studioPlaybackInfo;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                playbackId = typeof args === 'string' ? args : args.playbackId;
                urlEncodedPlaybackId = encodeURIComponent(playbackId);
                _context12.next = 4;
                return this._get("/playback/".concat(urlEncodedPlaybackId), {
                  headers: this._defaultHeaders
                });
              case 4:
                studioPlaybackInfo = _context12.sent;
                return _context12.abrupt("return", this._mapToPlaybackInfo(studioPlaybackInfo));
              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
      function getPlaybackInfo(_x14) {
        return _getPlaybackInfo.apply(this, arguments);
      }
      return getPlaybackInfo;
    }()
  }, {
    key: "_getPlaybackUrl",
    value: function _getPlaybackUrl(playbackId) {
      return "https://livepeercdn.com/hls/".concat(playbackId, "/index.m3u8");
    }
  }, {
    key: "getAssetMetrics",
    value: function () {
      var _getAssetMetrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(args) {
        var assetId, studioViewsMetrics;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                assetId = typeof args === 'string' ? args : args.assetId;
                _context13.next = 3;
                return this._get("/data/views/".concat(assetId, "/total"), {
                  headers: this._defaultHeaders
                });
              case 3:
                studioViewsMetrics = _context13.sent;
                return _context13.abrupt("return", this._mapToViewsMetrics(studioViewsMetrics));
              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
      function getAssetMetrics(_x15) {
        return _getAssetMetrics.apply(this, arguments);
      }
      return getAssetMetrics;
    }()
  }, {
    key: "_mapToStream",
    value: function () {
      var _mapToStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(studioStream) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.t0 = _objectSpread2;
                _context14.t1 = _objectSpread2({}, studioStream);
                _context14.t2 = {};
                _context14.next = 5;
                return this._mapToMultistream(studioStream.multistream);
              case 5:
                _context14.t3 = _context14.sent;
                _context14.t4 = this._getRtmpIngestUrl(studioStream.streamKey);
                _context14.t5 = this._getPlaybackUrl(studioStream.playbackId);
                _context14.t6 = {
                  multistream: _context14.t3,
                  rtmpIngestUrl: _context14.t4,
                  playbackUrl: _context14.t5
                };
                return _context14.abrupt("return", (0, _context14.t0)(_context14.t1, _context14.t2, _context14.t6));
              case 10:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
      function _mapToStream(_x16) {
        return _mapToStream2.apply(this, arguments);
      }
      return _mapToStream;
    }()
  }, {
    key: "_mapToMultistream",
    value: function () {
      var _mapToMultistream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(studioMultistream) {
        var _this3 = this;
        var fetchTargets;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (studioMultistream !== null && studioMultistream !== void 0 && studioMultistream.targets) {
                  _context16.next = 2;
                  break;
                }
                return _context16.abrupt("return", undefined);
              case 2:
                fetchTargets = studioMultistream.targets.map( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(t) {
                    var _yield$_this3$_get, name;
                    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            _context15.next = 2;
                            return _this3._get("/multistream/target/".concat(t.id), {
                              headers: _this3._defaultHeaders
                            });
                          case 2:
                            _yield$_this3$_get = _context15.sent;
                            name = _yield$_this3$_get.name;
                            return _context15.abrupt("return", _objectSpread2(_objectSpread2({}, t), {}, {
                              spec: {
                                name: name
                              }
                            }));
                          case 5:
                          case "end":
                            return _context15.stop();
                        }
                      }
                    }, _callee15);
                  }));
                  return function (_x18) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                _context16.next = 5;
                return Promise.all(fetchTargets);
              case 5:
                _context16.t0 = _context16.sent;
                return _context16.abrupt("return", {
                  targets: _context16.t0
                });
              case 7:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));
      function _mapToMultistream(_x17) {
        return _mapToMultistream2.apply(this, arguments);
      }
      return _mapToMultistream;
    }()
  }, {
    key: "_mapToPlaybackInfo",
    value: function _mapToPlaybackInfo(studioPlaybackInfo) {
      var _studioPlaybackInfo$m, _studioPlaybackInfo$m2, _studioPlaybackInfo$m3;
      return {
        type: studioPlaybackInfo === null || studioPlaybackInfo === void 0 ? void 0 : studioPlaybackInfo['type'],
        meta: {
          live: studioPlaybackInfo !== null && studioPlaybackInfo !== void 0 && (_studioPlaybackInfo$m = studioPlaybackInfo['meta']) !== null && _studioPlaybackInfo$m !== void 0 && _studioPlaybackInfo$m['live'] ? Boolean(studioPlaybackInfo === null || studioPlaybackInfo === void 0 ? void 0 : studioPlaybackInfo['meta']['live']) : false,
          source: studioPlaybackInfo === null || studioPlaybackInfo === void 0 ? void 0 : (_studioPlaybackInfo$m2 = studioPlaybackInfo['meta']) === null || _studioPlaybackInfo$m2 === void 0 ? void 0 : (_studioPlaybackInfo$m3 = _studioPlaybackInfo$m2['source']) === null || _studioPlaybackInfo$m3 === void 0 ? void 0 : _studioPlaybackInfo$m3.map(function (source) {
            return {
              hrn: source === null || source === void 0 ? void 0 : source['hrn'],
              type: source === null || source === void 0 ? void 0 : source['type'],
              url: source === null || source === void 0 ? void 0 : source['url']
            };
          })
        }
      };
    }
  }, {
    key: "_mapToViewsMetrics",
    value: function _mapToViewsMetrics(studioMetrics) {
      return {
        type: 'ViewsMetrics',
        metrics: studioMetrics
      };
    }
  }]);
  return StudioLivepeerProvider;
}(BaseLivepeerProvider);
var definedProps = function definedProps() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.fromEntries(Object.entries(obj).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2);
      _ref6[0];
      var v = _ref6[1];
    return typeof v !== 'undefined';
  }));
};
function studioProvider(config) {
  return function () {
    return new StudioLivepeerProvider(_objectSpread2(_objectSpread2({}, defaultStudioConfig), definedProps(config)));
  };
}

export { StudioLivepeerProvider, studioProvider };
